import { useTranslation } from 'react-i18next';
import { formatNumber, scrollToElementById } from '../../../core/helpers';
import './SellerRecommendations.scss';
import { ReactComponent as PlusIcon } from '../../../icons/plus-circle.svg';
import Collapse from '../../../components/Collapse/Collapse';
import { useState } from 'react';
import Button from '../../../components/Button';

const WAYS = [
  { label: 'Set up Amazon FBA Pan-European', prfitBoost: 1200 },
  { label: 'Set up Amazon FBA Central Europe', prfitBoost: 800 },
  { label: 'Start using warehouses in France', prfitBoost: 423 },
  { label: 'Start selling on amazon.fr', prfitBoost: 200 },
  { label: 'Start selling on amazon.se', prfitBoost: 150 },
];

const generateId = (v: string) => {
  return v.toLowerCase().split(' ').join('-');
};

export default function SellerRecommendations() {
  const { t } = useTranslation();
  const [activeCollapses, setActiveCollapses] = useState([
    'Start using warehouses in France',
  ]);

  const onCollpaseBtnClick = (id: string) => () => {
    setActiveCollapses((p) => {
      if (p.includes(id)) {
        return p.filter((s) => s !== id);
      }
      return [...p, id];
    });
  };

  const renderContent =
    (country: string) =>
    (
      ref: React.MutableRefObject<HTMLDivElement | null>,
      toggleCollapse: () => void
    ) => {
      return (
        <div ref={ref}>
          <div className='row mx-0 border-top pt-2 mb-2'>
            <div className='col-5 ps-0 Text--gray'>
              {t('Single time spendings')}
            </div>
            <div className='col pe-0'>
              <div className='d-flex justify-content-between'>
                <div>{t('VAT ID registration')} </div>
                <div>
                  {formatNumber(449, {
                    currency: 'eur',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className='row mx-0 border-top pt-2 mb-2'>
            <div className='col-5 ps-0 Text--gray'>{t('Monthly spedings')}</div>
            <div className='col pe-0'>
              <div className='d-flex justify-content-between mb-2'>
                <div>{t('VAT filing')}</div>
                <div>
                  {formatNumber(89, {
                    currency: 'eur',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  })}
                </div>
              </div>
              <div className='d-flex justify-content-between mb-2'>
                <div>{t('countX Service fees')}</div>
                <div>
                  {formatNumber(49, {
                    currency: 'eur',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  })}
                </div>
              </div>
              <div className='d-flex justify-content-between mb-2'>
                <div>{t('Amazon fees')}</div>
                <div>
                  {formatNumber(39, {
                    currency: 'eur',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between mx-0 border-top pt-2 mb-2'>
            <div className='Text--gray'>{t('Total spendings')}</div>
            <div>177€/mo</div>
          </div>
          <div className='d-flex justify-content-between mx-0 border-top pt-2 mb-3'>
            <div>
              <div className='Text--gray'>{t('Profits')}</div>
              <div className='Text--sm'>
                {t('On each parcel sold in *country* you save *n*€')
                  .replace('*country*', t('FR'))
                  .replace('*n*', String('0.5'))}
              </div>
            </div>
            <div>1.5 € ×1,200= 600€/mo</div>
          </div>
          <div className='d-flex justify-content-between mx-0 border-top pt-2 mb-4 pb-1'>
            <div className='Text--gray'>{t('Total Profit')}</div>
            <div className='text-end'>
              <div>600€-177€ = 423€/mo</div>
              <div className='Text--sm'>
                {t('starting from the third month')}
              </div>
            </div>
          </div>
          <div className='SellerRecommendations__separator SellerRecommendations__separator--sm mx-n4' />

          <div className='row mx-0 pt-2 mb-3'>
            <div className='col ps-0'>
              <div className='Text--gray mb-2'>{t('Benefits')}</div>
              <div className='mb-2'>
                {t('Fast delivery through Amazon Prime')}
              </div>
              <div className='mb-2'>
                {t('Extremely high number of visitors')}
              </div>
              <div className='mb-2'>{t('Trust of customers')}</div>
              <div className='mb-2'>
                {t(
                  'Fragile products are well protected by Amazon’s packaging.'
                )}
              </div>
              <div className='mb-2'>
                {t('Returns: Amazon takes care of it')}
              </div>
              <div className='mb-2'>
                {t('Flexibility in location (worldwide shipping)')}
              </div>
              <div>{t('Weekly payout')}</div>
            </div>
            <div className='col pe-0'>
              <div className='Text--gray mb-2'>{t('Drawbacks')}</div>
              <div className='mb-2'>
                {t('Large quantities required for purchases')}
              </div>
              <div className='mb-2'>
                {t(
                  'For returns of damaged products, usually, only about half of the product price is refunded. This can result in losses'
                )}
              </div>
              <div>
                {t(
                  'No influence on return policies (Amazon prioritizes the end customer experience over the impact on Amazon Sellers)'
                )}
              </div>
            </div>
          </div>
          <div className='row row-cols-auto align-items-center'>
            <div className='col'>
              <Button className='py-2 px-3'>
                {t(
                  'Contact manager to register warehouse in *country*'
                ).replace('*country*', t(country))}
              </Button>
            </div>
            <div className='col'>
              <Button
                styling='naked'
                className='fw-600'
                onClick={toggleCollapse}
              >
                {t('Hide details')}
              </Button>
            </div>
          </div>
        </div>
      );
    };

  return (
    <div className='Page flex-grow-1'>
      <div className='container'>
        <div className='Paper p-4 Paper--md mx-auto'>
          <div className='pb-4 mb-3'>
            <div className='Text--30 fw-900 mb-4'>{t('Stages of growth')}</div>
            <div className='row'>
              <div className='col'>
                <div className='Text--20 fw-800 mb-3'>{t('Your setup')}</div>
                <div className='SellerRecommendations__card'>
                  <div className='SellerRecommendations__label position-relative SellerRecommendations__gradient1 fw-800'>
                    {t('Medium size business')}
                  </div>
                  <div className='px-3'>
                    <div className='pt-2 pb-3'>
                      <div className='Text--gray'>{t('Marketplaces')}</div>
                      <div className='fw-600'>amazon.de</div>
                      <div>
                        {t('Sales to')}:{' '}
                        {['DE', 'FR', 'AT', 'DK', 'SE', 'IT']
                          .map((c) => t(c))
                          .join(', ')}
                      </div>
                    </div>
                    <div className='pt-2 pb-3 border-top'>
                      <div className='Text--gray'>{t('Amazon programs')}</div>
                      <div className='fw-600'>{t('Not started')}</div>
                    </div>
                    <div className='pt-2 pb-3 border-top'>
                      <div className='Text--gray'>{t('Warehouses')}</div>
                      <div className='fw-600'>{t('PL')}</div>
                    </div>
                    <div className='SellerRecommendations__separator mx-n3' />
                    <div className='pt-2 pb-3'>
                      <div className='Text--gray'>
                        {t('Cross-border sales last month')}
                      </div>
                      <div className='fw-600'>
                        {formatNumber(9613200 / 100, {
                          currency: 'eur',
                        })}
                      </div>
                      <div className='row row-cols-auto gx-2 SellerRecommendations__crossBorderRow'>
                        {[
                          {
                            country: 'FR',
                            amount: 6593000,
                          },
                          {
                            country: 'AT',
                            amount: 3000000,
                          },
                          {
                            country: 'DK',
                            amount: 95400,
                          },
                          {
                            country: 'SE',
                            amount: 123400,
                          },
                          {
                            country: 'IT',
                            amount: 5300,
                          },
                        ].map((s) => (
                          <div key={s.country} className='col text-nowrap'>
                            {t(s.country)}:{' '}
                            {formatNumber(s.amount / 100, {
                              currency: 'eur',
                            })}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className='pt-2 pb-3 border-top'>
                      <div className='Text--gray'>{t('Commissions paid')}</div>
                      <div className='mb-2 fw-600'>
                        {formatNumber(2443000 / 100, {
                          currency: 'eur',
                        })}
                      </div>
                      <Button styling='naked-blue'>{t('Details')}</Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col'>
                <div className='Text--20 fw-800 mb-3'>{t('Ways to Grow')}</div>
                {WAYS.map((w, i) => (
                  <button
                    key={w.label}
                    className={`border-0 w-100 fw-600 mb-2 SellerRecommendations__way SellerRecommendations__way--${
                      i + 1
                    } d-flex`}
                    onClick={() => {
                      if (!activeCollapses.includes(w.label)) {
                        setActiveCollapses((p) => [...p, w.label]);
                      }
                      setTimeout(() => {
                        scrollToElementById(generateId(w.label));
                      }, 150);
                    }}
                  >
                    <PlusIcon className='me-2' />
                    {w.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className='SellerRecommendations__separator mx-n4' />
          <div className='pt-3'>
            <div className='mb-3 fw-800'>{t('Growing options')}</div>
            {WAYS.map((w, i) => (
              <div
                className={`SellerRecommendations__card SellerRecommendations__option--${
                  i + 1
                } pt-2 pb-3 px-4 position-relative mb-2`}
                key={w.label}
                id={generateId(w.label)}
              >
                <Collapse
                  externalControl={{
                    isOpened: activeCollapses.includes(w.label),
                    onTriggerClick: onCollpaseBtnClick(w.label),
                  }}
                  triggerRenderer={(isOpened, toggleCollapse) => {
                    return (
                      <div>
                        <div className='d-flex justify-content-between'>
                          <div className='fw-800'>{t(w.label)}</div>
                          <div className='fw-800'>
                            {t('profit boost')} ≈
                            {formatNumber(w.prfitBoost, {
                              maximumFractionDigits: 0,
                              minimumFractionDigits: 0,
                            })}
                            €/mo
                          </div>
                        </div>
                        <div>
                          {t(
                            'You already sell to France *n* products per month.'
                          ).replace('*n*', String(1230))}
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t(
                              'Warehouse usage on avarage <i>increase</i> sales about *n*%.'
                            ).replace('*n*', String(20)),
                          }}
                        />
                        <div className='mb-2'>
                          {t(
                            'If you start using warehouse in France your spendings and savings would be:'
                          )}
                        </div>
                        {!isOpened && (
                          <Button styling='naked-blue' onClick={toggleCollapse}>
                            {t('Show details')}
                          </Button>
                        )}
                      </div>
                    );
                  }}
                  contentRenderer={renderContent('FR')}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
